import { createIcon } from '@chakra-ui/react';

export const OneXbetAmountIcon = createIcon({
  displayName: 'OneXbetAmountIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d='M21 4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H21C22.1 20 23 19.1 23 18V6C23 4.9 22.1 4 21 4ZM21 18H3V12H21V18ZM21 8H3V6H21V8Z'
      fill='currentColor'
    />
  ),
});

export const OneXbetCardNumberIcon = createIcon({
  displayName: 'OneXbetCardNumberIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d='M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z'
      fill='currentColor'
    />
  ),
});

export const OneXbetBankIcon = createIcon({
  displayName: 'OneXbetBankIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d='M5 10V20H7V10H5ZM11 10V20H13V10H11ZM3 21H21V23H3V21ZM17 10V20H19V10H17ZM12 4L4 8V10H20V8L12 4Z'
      fill='currentColor'
    />
  ),
});

export const OneXbetRecipientIcon = createIcon({
  displayName: 'OneXbetRecipientIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d='M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z'
      fill='currentColor'
    />
  ),
});

export const OneXbetAlertIcon = createIcon({
  displayName: 'OneXbetAlertIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z'
      fill='currentColor'
    />
  ),
});

export const OneXbetWalletIcon = createIcon({
  displayName: 'OneXbetWalletIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d='M4 6C4 4.9 4.9 4 6 4H18C19.1 4 20 4.9 20 6V18C20 19.1 19.1 20 18 20H6C4.9 20 4 19.1 4 18V6ZM6 8H18V18H6V8Z'
        fill='currentColor'
      />
      <path d='M7 5L9 3L11 5H7Z' fill='currentColor' />
      <path d='M13 5L15 3L17 5H13Z' fill='currentColor' />
      <path d='M20 5L22 7L20 9V5Z' fill='currentColor' />
      <circle cx='21' cy='7' r='1.5' fill='currentColor' />
    </>
  ),
});
